import { useEffect, useState } from 'react';
import { OFFER_DEADLINE_MS } from '../data/content';

export interface TimeLeft {
  hours: string;
  minutes: string;
  seconds: string;
  isOver: boolean;
}

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

function compute(): TimeLeft {
  const remaining = Math.max(0, OFFER_DEADLINE_MS - Date.now());
  const totalSeconds = Math.floor(remaining / 1000);
  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
    isOver: remaining === 0,
  };
}

export function useCountdown(): TimeLeft {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => compute());

  useEffect(() => {
    const id = window.setInterval(() => setTimeLeft(compute()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return timeLeft;
}
